module.exports = __webpack_public_path__ + "static/media/professional-teaching-ad6.9ef202b4.png";